import './blue-banner.scss';
import { getPicture } from '../../../assets/js/picture-maker';
import { sanitizeString } from '../../../assets/js/text-renderer';

const getBlueBanner = (data) => `
<div class="blue-banner row container">
  <article 
    id="${data.id}" 
    class="col-12 col-md-6 blue-banner__article"
  >
    ${data.content ? data.content : ''}
  </article>
  ${data.picture}
</div>
`;

/**
 * Custom Blue Banner Component
 * 
 * Attributes:
 * 
 * - content-id: Establece el identificador único para el artículo del componente.
 * 
 * - image-desktop: Establece la imagen que se mostrará en dispositivos de escritorio en el panel correspondiente.
 * 
 * - image-tablet: Establece la imagen que se mostrará en dispositivos tablet en el panel correspondiente.
 * 
 * - image-mobile: Establece la imagen que se mostrará en dispositivos móviles en el panel correspondiente.
 * 
 * - image-alt: Establece el texto alternativo para las imágenes del panel.
 * 
 */
class BlueBanner extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || ( 
      window['__PRERENDER_INJECTED'] && 
      window['__PRERENDER_INJECTED'].render_text)
    ) this.render();
  }

  render() {
    const content = this.querySelector(":scope > slot");
    const blueBannerData = this.getData(content);
    this.innerHTML = getBlueBanner(blueBannerData);
  }

  getData(content) {
    return {
      id: sanitizeString(content.getAttribute('content-id')),
      content: content.innerHTML,
      picture: getPicture(content, { customClass: 'col-12 col-md-6' }),
    }
  }
}

customElements.define('custom-blue-banner', BlueBanner);